<template>
  <div class="root">
    <hr />
    <p>{{ review.establishment.consultant.firstname }} a effectué un signalement.</p>
    <hr />
    <div class="content">
      <h4>Voici l'avis en question:</h4>
      <div class="field">
        <div class="control">
          <input class="input" type="text" :value="review.title_fr" disabled />
        </div>
      </div>
      <div class="field">
        <div class="control">
          <textarea class="textarea" rows="10" :value="review.text_fr" disabled></textarea>
        </div>
      </div>
      <div>
        <p class="is-pulled-right">{{ review.author }}</p>
        <p>{{ review.mark }} / 10</p>
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EstablishmentStateSignalingSent",
  props: {
    review: {
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
</style>